// extracted by mini-css-extract-plugin
module.exports = {"login":"style__login__cIfKR"};